import React from 'react';
import { Popup, PopupText } from 'features/nekst-widgets';
import { NewLine, TextLink, usePopupManager } from 'ui-builder';

export function EventTaskConfigurationInfoPopup(
  props: {
    openSettingsFunc: () => void,
  }
) {
  const popupManager = usePopupManager();

  return (
    <Popup
      title="Event Tasks Setup"
      content={
        <PopupText>
          In order to use Event Tasks, please link your Calendar to a Google Calendar from the Settings page.

          <NewLine />
          <NewLine />
          Go to
          {' '}
          <TextLink onClick={() => {
            props.openSettingsFunc();
            popupManager.closePopup();
          }}>
            Calendar Integration
          </TextLink>
          {' '}
          in Settings
        </PopupText>
      }
    />
  );
}
